export default {
	flipY: true,
	flipHeight: 12,
	charX: 13,
	charY: 22,
	' ': ['X'], // next char command
	'\n': ['Y'], // next line command
	'0': ['0 0 8 0 8 12 0 12 0 0 8 12 X'],
	'1': ['4 0 4 12 3 10 X'],
	'2': ['0 12 8 12 8 7 0 5 0 0 8 0 X'],
	'3': ['0 12 8 12 8 0 0 0','0 6 8 6 X'],
	'4': ['0 12 0 6 8 6','8 12 8 0 X'],
	'5': ['0 0 8 0 8 6 0 7 0 12 8 12 X'],
	'6': ['0 12 0 0 8 0 8 5 0 7 X'],
	'7': ['0 12 8 12 8 6 4 0 X'],
	'8': ['0 0 8 0 8 12 0 12 0 0','0 6 8 6 X'],
	'9': ['8 0 8 12 0 12 0 7 8 5 X'],
	'.': ['3 0 4 0 X'],
	',': ['2 0 4 2 X'],
	'-': ['2 6 6 6 X'],
	'+': ['0 6 8 6','4 10 4 2 X'],
	'!': ['4 -1 4 1','4 6 4 14 X'],
	'#': ['0 4 8 4 6 2 6 10 8 8 0 8 2 10 2 2 X'],
	'^': ['0 4 4 0 12 12 X'],
	'=': ['1 4 7 4','1 8 7 8 X'],
	'*': ['0 0 4 12 8 0 0 8 8 8 0 0 X'],
	'_': ['0 0 8 0 X'],
	'/': ['0 0 8 12 X'],
	'@': ['8 4 4 0 0 4 0 8 4 12 8 8 4 4 3 6 X'],
	'$': ['6 2 2 6 6 10','4 12 4 0 X'],
	'&': ['8 0 4 12 8 8 0 4 4 0 8 4 X'],
	'[': ['6 0 2 0 2 12 6 12 X'],
	']': ['2 0 6 0 6 12 2 12 X'],
	'(': ['6 0 2 4 2 8 6 12 X'],
	')': ['2 0 6 4 6 8 2 12 X'],
	'{': ['6 0 4 2 4 10 6 12','2 6 4 6 X'],
	'}': ['4 0 6 2 6 10 4 12','6 6 8 6 X'],
	'%': ['0 0 8 12','2 10 2 8','6 4 6 2 X'],
	'<': ['6 0 2 6 6 12 X'],
	'>': ['2 0 6 6 2 12 X'],
	'|': ['4 0 4 5','4 6 4 12 X'],
	':': ['4 10 4 8','4 4 4 2 X'],
	';': ['4 10 4 8','4 4 1 1 X'],
	'"': ['2 10 2 6','6 10 6 6 X'],
	"'": ['3 12 5 8 X'],
	'~': ['0 4 2 8 6 4 8 8 X'],
	'?': ['0 8 4 12 8 8 4 4','4 1 4 0 X'],
	'A': ['0 0 0 8 4 12 8 8 8 0','0 4 8 4 X'],
	'B': ['0 0 0 12 4 12 8 10 4 6 8 2 4 0 0 0 X'],
	'C': ['8 0 0 0 0 12 8 12 X'],
	'D': ['0 0 0 12 4 12 8 8 8 4 4 0 0 0 X'],
	'E': ['8 0 0 0 0 12 8 12','0 6 6 6 X'],
	'F': ['0 0 0 12 8 12','0 6 6 6 X'],
	'G': ['6 6 8 4 8 0 0 0 0 12 8 12 X'],
	'H': ['0 0 0 12','0 6 8 6','8 12 8 0 X'],
	'I': ['0 0 8 0','4 0 4 12','0 12 8 12 X'],
	'J': ['0 4 4 0 8 0 8 12 X'],
	'K': ['0 0 0 12','8 12 0 6 6 0 X'],
	'L': ['8 0 0 0 0 12 X'],
	'M': ['0 0 0 12 4 8 8 12 8 0 X'],
	'N': ['0 0 0 12 8 0 8 12 X'],
	'O': ['0 0 0 12 8 12 8 0 0 0 X'],
	'P': ['0 0 0 12 8 12 8 6 0 5 X'],
	'Q': ['0 0 0 12 8 12 8 4 0 0','4 4 8 0 X'],
	'R': ['0 0 0 12 8 12 8 6 0 5','4 5 8 0 X'],
	'S': ['0 2 2 0 8 0 8 5 0 7 0 12 6 12 8 10 X'],
	'T': ['0 12 8 12','4 12 4 0 X'],
	'U': ['0 12 0 1 4 0 8 1 8 12 X'],
	'V': ['0 12 4 0 8 12 X'],
	'W': ['0 12 2 0 4 4 6 0 8 12 X'],
	'X': ['0 0 8 12','0 12 8 0 X'],
	'Y': ['0 12 4 6 8 12','4 6 4 0 X'],
	'Z': ['0 12 8 12 0 0 8 0','2 6 6 6 X']
}